import { EntityCollection } from "models/list-user-entity-collection";
import { doDelete, doPatch } from "../request";

export const adminDoPatchEntityCollection = async (
  listUuid: string,
  listUserUuid: string,
  entityUuid: string,
  collectionUuid: string,
  entityCollection: EntityCollection,
) => {
  await doPatch(
    `/admin/list/${listUuid}/user/${listUserUuid}/entity/${entityUuid}/collection/${collectionUuid}`,
    entityCollection,
  );
};

export const adminDoDeleteEntityCollection = async (
  listUuid: string,
  listUserUuid: string,
  entityUuid: string,
  collectionUuid: string,
) => {
  await doDelete(
    `/admin/list/${listUuid}/user/${listUserUuid}/entity/${entityUuid}/collection/${collectionUuid}`,
  );
};
